import styled from 'styled-components';

export const ContentStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    
    > svg {
        margin-left: 8px;
        fill: var(--color-base);
    }
`;